import React from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
} from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const OTPGeneration = ({ onComplete }) => {
  const { t, language } = useTranslation();
  const isRtl = language === 'ar';

  const steps = [
    {
      title: t('ZatcaOnboarding.OTPGeneration.Steps.Step1_Title'),
      description: t('ZatcaOnboarding.OTPGeneration.Steps.Step1_Desc'),
    },
    {
      title: t('ZatcaOnboarding.OTPGeneration.Steps.Step2_Title'),
      description: t('ZatcaOnboarding.OTPGeneration.Steps.Step2_Desc'),
    },
    {
      title: t('ZatcaOnboarding.OTPGeneration.Steps.Step3_Title'),
      description: t('ZatcaOnboarding.OTPGeneration.Steps.Step3_Desc'),
    },
    {
      title: t('ZatcaOnboarding.OTPGeneration.Steps.Step4_Title'),
      description: t('ZatcaOnboarding.OTPGeneration.Steps.Step4_Desc'),
    }
  ];

  return (
    <Box dir={isRtl ? 'rtl' : 'ltr'} sx={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      <Card 
        variant="outlined" 
        sx={{ 
          mb: 4,
          borderRadius: 0,
          borderColor: 'divider',
          width: '100%',
          minHeight: 420
        }}
      >
        <CardContent>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              mb: 3,
              fontWeight: 500,
              color: 'text.secondary',
              fontSize: '0.875rem',
              textAlign: isRtl ? 'right' : 'left'
            }}
          >
            {t('ZatcaOnboarding.OTPGeneration.Title')}
          </Typography>

          <Stack spacing={2}>
            {steps.map((item, index) => (
              <Box
                key={index}
                sx={{
                  p: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 0,
                  bgcolor: 'background.paper',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2
                }}
              >
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    flexShrink: 0
                  }}
                >
                  {index + 1}
                </Box>
                <Box sx={{ flex: 1, textAlign: isRtl ? 'right' : 'left' }}>
                  <Typography 
                    variant="subtitle1" 
                    sx={{ 
                      fontWeight: 500,
                      color: 'text.primary',
                      mb: 0.5,
                      textAlign: isRtl ? 'right' : 'left'
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: 'text.secondary',
                      lineHeight: 1.4,
                      textAlign: isRtl ? 'right' : 'left'
                    }}
                  >
                    {item.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: isRtl ? 'flex-end' : 'flex-start', alignItems: 'center' }}>
            <Button
              variant="outlined"
              href="https://fatoora.zatca.gov.sa"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ 
                borderRadius: 0,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                px: 3,
                py: 1,
                width: { xs: '100%', sm: 'auto' }
              }}
            >
              {t('ZatcaOnboarding.OTPGeneration.Portal_Button')}
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', justifyContent: isRtl ? 'flex-start' : 'flex-end' }}>
        <Button
          variant="contained"
          onClick={onComplete}
          sx={{ 
            px: 3,
            py: 1,
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          {t('ZatcaOnboarding.OTPGeneration.Complete_Button')}
        </Button>
      </Box>
    </Box>
  );
};

export default OTPGeneration;